import { QueryParameter } from '@/shared/constants/queryParams';
import { promoContentIdVar } from '@/scenarios/legacy-player/components/movie-player/hooks/use-promo-content-id-var';

import { QueryParams } from '../types';

export const enrichPromoParamsIfNeed = (paramsToAdd: QueryParams): QueryParams => {
    const updatedParams = { ...paramsToAdd };
    const promoContentId = promoContentIdVar.get();
    if (promoContentId) {
        updatedParams[QueryParameter.PROMO] = '1';
        updatedParams[QueryParameter.REDIRECT_TO_FILM_PAGE] = promoContentId;
    }
    return updatedParams;
};
